import { render, staticRenderFns } from "./MessageTokenEditor.vue?vue&type=template&id=3e8f6475"
import script from "./MessageTokenEditor.vue?vue&type=script&lang=js"
export * from "./MessageTokenEditor.vue?vue&type=script&lang=js"
import style0 from "./MessageTokenEditor.vue?vue&type=style&index=0&id=3e8f6475&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports